export enum meetingPlaces {
  teleconsultation = 'Teleconsultation',
}
